import React, { Component } from 'react';
import './index.css';
import Header from './components/sections/Header';
import Intro from './components/sections/Intro';
import About from './components/sections/About';
import Products from './components/sections/Products';
import Contact from './components/sections/Contact';
import Footer from './components/sections/Footer';

class App extends Component {
	render() {
		return (
			<>
				<Header />
				<div style={{ overflowX: 'hidden' }}>
					<Intro />
					<About />
					<Products />
					<Contact />
				</div>
				<Footer />
			</>
		);
	}
}

export default App;
